import { useContext } from 'react'

import { Select } from '@mantine/core'

import { RecruitersContext } from 'src/context/RecruitersContext'

import { inlineSelectProps } from './inlineSelectStyles'

const LeadEmployeeOptions = ({ action, setSelected }) => {
  const recruiters = useContext(RecruitersContext) ?? []

  return (
    <div className="flex flex-col gap-3 text-xs">
      {recruiters.length === 0 ? (
        <div className="text-xs text-doubleNickel-gray-500">
          No recruiters found.
        </div>
      ) : (
        <Select
          {...inlineSelectProps}
          value={action?.leadEmployeeId ?? null}
          onChange={(value) => setSelected({ leadEmployeeId: value })}
          data={recruiters}
          className="max-w-sm"
          searchable
          clearable
        />
      )}
    </div>
  )
}

export default LeadEmployeeOptions
